import React from 'react';

export const SOURCE_TYPES = ['website', 'careers', 'news', 'linkedin', 'other'];

// One registered source. `gated` means the company above it is switched off, so
// nothing here is scanned — the row is dimmed but KEPT, because switching the
// company back on resumes it.
export default function SourceRow({
  source, mode, gated, selected, busy = false, onToggleActive, onSelect, onRemove, onChangeType,
}) {
  const edit = mode === 'edit';
  return (
    <div className={`flex items-center gap-3 px-4 py-2.5 pl-9 border-b border-gray-100 last:border-b-0 ${gated ? 'opacity-50' : ''}`}>
      {edit && (
        <input
          type="checkbox"
          className="w-3.5 h-3.5 accent-[#00C6AE] shrink-0"
          aria-label={`Select ${source.url}`}
          checked={selected}
          onChange={() => onSelect(source)}
        />
      )}
      <div className="flex-1 min-w-0">
        <div className="font-mono text-sm text-gray-900 break-all">{source.url}</div>
        {source.note && <div className="text-xs text-gray-500 mt-0.5">{source.note}</div>}
      </div>
      {edit ? (
        <select
          className="text-xs border border-gray-200 rounded px-1.5 py-1 shrink-0"
          aria-label={`Type of ${source.url}`}
          value={source.source_type}
          disabled={busy}
          onChange={(e) => onChangeType(source, e.target.value)}
        >
          {SOURCE_TYPES.map((t) => <option key={t} value={t}>{t}</option>)}
        </select>
      ) : (
        <span className="text-[10px] uppercase tracking-wide text-gray-500 border border-gray-200 rounded px-2 py-0.5 shrink-0">
          {source.source_type}
        </span>
      )}
      <label className="relative inline-block w-8 h-5 shrink-0">
        <input
          type="checkbox"
          className="absolute inset-0 opacity-0 cursor-pointer"
          aria-label={`${source.is_active ? 'On' : 'Off'} ${source.url}`}
          checked={source.is_active}
          disabled={busy}
          onChange={() => onToggleActive(source, !source.is_active)}
        />
        <span className={`absolute inset-0 rounded-full transition-colors ${source.is_active ? 'bg-[#00C6AE]' : 'bg-gray-300'}`}>
          <span className={`absolute top-0.5 w-4 h-4 rounded-full bg-white shadow transition-transform ${source.is_active ? 'translate-x-3.5' : 'translate-x-0.5'}`} />
        </span>
      </label>
      {edit && (
        <button
          type="button"
          disabled={busy}
          onClick={() => onRemove(source)}
          className="text-xs text-red-700 hover:bg-red-50 rounded px-2 py-1 shrink-0 disabled:opacity-40"
        >
          Remove
        </button>
      )}
    </div>
  );
}
